import "./style.scss";
import { activateEnquiry } from "./enquiry";

const images = document.querySelectorAll("img");
const totalImages = images.length;
let loadedCount = 0;
const totalBlocks = 12;
const blockElements = document.querySelectorAll(".block1");

function updateProgress() {
  const percent = Math.floor((loadedCount / totalImages) * 100);

  const blocksToShow = Math.floor((percent / 100) * totalBlocks);

  blockElements.forEach((block, index) => {
    if (index < blocksToShow) {
      block.classList.add("visible");
    }
  });

  if (loadedCount === totalImages) {
    setTimeout(showpage, 500);
  }
}
images.forEach((img) => {
  if (img.complete) {
    loadedCount++;
    updateProgress();
  } else {
    img.onload = img.onerror = () => {
      loadedCount++;
      updateProgress();
    };
  }
});

const dotsEl = document.getElementById("dots");
let dotCount = 0;

setInterval(() => {
  dotCount = (dotCount + 1) % 4;
  dotsEl.textContent = ".".repeat(dotCount);
}, 500);

window.onload = () => {
  window.addEventListener("message", function (e) {
    if (e.data.message == "preload_complete") {
      setTimeout(showpage, 500);
    }
  });
};

function showpage() {
  document.querySelector(".page_loader").classList.add("disabled");
  activateEnquiry("snam-vietnam");
}
